function Inksoft () {
}

Inksoft.funcs = {
    isInitConflictingColorsEvents: true,

    launchInksoft: function(flashvars, element) {
        launchDesigner('HTML5DS', flashvars, element);
    },

    initEvents: function() {
        var self = this;

        if (self.isInitConflictingColorsEvents) {
            $(".modifier_main_container").on("click", ".conflicting-color-edit-logo", self.editConflictingColors);
            $(".modifier_main_container").on("click", ".conflicting-color-change-logo", self.changeLogo);

            self.isInitConflictingColorsEvents = false;
        }
    },

    editConflictingColors: function() {
        var code = $(this).data("application-code");
        var applicationObject = ub.funcs.getApplicationSettings(code);

        if (typeof applicationObject !== "undefined") {
            if (typeof applicationObject.embellishment !== "undefined") {
                var embellishmentObject = applicationObject.embellishment;

                Inksoft.funcs.checkColorConflict(embellishmentObject.design_details, function(hasConflict, colors) {
                    if (hasConflict) {
                        ub.data.isMessageIsCalled = true;
                        Inksoft.funcs.launchDesignerWithColorConflict(embellishmentObject.design_id, applicationObject.code, colors);
                    }
                });
            }
        }
    },

    changeLogo: function() {
        var code = $(this).data("application-code");
        var applicationObject = ub.funcs.getApplicationSettings(code);
        ub.data.isChangeStockLogo = true;
        
        if (typeof applicationObject !== "undefined") {
            ub.data.currentApplication = applicationObject;

            if (typeof applicationObject.embellishment !== "undefined") {
                var embellishmentObject = applicationObject.embellishment;

                if (applicationObject.logo_type === 'stock' || applicationObject.logo_type === 'custom') {
                    StockMascot.events.init();
                } else if (applicationObject.logo_type === 'custom_text') {
                    StockMascot.events.init(ub.data.customTextCategoryID, embellishmentObject.design_id);
                }
            }
        }
    },

    checkColorConflict: function(inksoftDesignDetails, callback) {
        Inksoft.funcs.getDesignColors(inksoftDesignDetails, function(colors) {
            var noneExistenceColors = Inksoft.funcs.checkHexCode(colors);
            if (_.isFunction(callback)) {
                var hasConflict = _.size(noneExistenceColors) > 0 ? true : false;
                callback(hasConflict, noneExistenceColors);
            } else {
                if (_.size(noneExistenceColors) > 0) {
                    return {
                        hasConflict: true,
                        colors: noneExistenceColors
                    }
                } else {
                    return {
                        hasConflict: false,
                        colors: []
                    }
                }
            }
        });
    },

    getDesignColors: function(inksoftDesignDetails, callback) {
        var elements;
        var colorList = [];

        if (typeof inksoftDesignDetails !== 'undefined' && inksoftDesignDetails !== '') {
            if (typeof inksoftDesignDetails.Data !== "undefined") {
                elements = inksoftDesignDetails.Data.Canvases[0].Elements;
            } else {
                elements = inksoftDesignDetails.Canvases[0].Elements;
            };

            if (typeof elements !== "undefined") {
                _.each(elements, function(element) {
                    if (typeof element.Colors === "object") {
                        colorList.push(element.Colors)
                    } else {
                        // Check if text has stroke
                        if (_.has(element, 'StrokeWidth') && element.StrokeWidth && element.StrokeWidth !== 0) {
                            colorList.push(element.StrokeColor);
                        }
    
                        // Get Fill color
                        colorList.push(element.FillColor);
                    }
                });
            } else {
                console.log("Cannot find Design Details")
            }            
        } else {
            console.log("Cannot find Design Details")
        }

        var flattenResult = _.flatten(colorList);
        var uniqColors = _.uniq(flattenResult);

        if (_.isFunction(callback)) {
            callback(uniqColors);
        } else {
            return uniqColorsl;
        }
    },

    checkHexCode: function(colors) {
        var unrecognizedColorList = [];

        _.each(colors, function(color) {
            if (color !== "" && color !== "none") {
                var hexCode = color.replace("#", "");
                var colorObject = _.find(ub.data.colors, {hex_code: hexCode.toLowerCase()});

                if (typeof colorObject === "undefined") {
                    unrecognizedColorList.push({
                        "color_code": color
                    });
                }
            }
        });

        return unrecognizedColorList;
    },

    renderConflictingColors: function(colors, application_code) {
        var template = document.getElementById("conflicting-colors-inksoft").innerHTML;
        var renderTemplate = Mustache.render(template, {
            colors: colors,
            application_code: application_code
        });

        return renderTemplate;
    },

    launchDesignerWithColorConflict: function(designID, applicationID, colors) {
        var flashvars = InteropIsPanel.getDesignLoaderFlashVar(designID, applicationID);

        // Element
        var editorElement = "#inksoft-color-conflict-editor .inksoft-design-editor";
        $(editorElement).html("");
        var element = document.querySelector(editorElement);
        
        if (ub.config.isInksoftAvailable === "yes") {
            Inksoft.funcs.launchInksoft(flashvars, element);

            var template = document.getElementById("conflicting-color-list").innerHTML;
            var renderTemplate = Mustache.render(template, {
                colors: colors
            });

            $("#inksoft-color-conflict-editor .list-of-conflicting-colors").html("");
            $("#inksoft-color-conflict-editor .list-of-conflicting-colors").html(renderTemplate);

            UIkit.modal("#inksoft-color-conflict-editor").show();
        } else {
            ub.utilities.notifyMe("Inksoft is currently under maintenance. Please try again later.", "danger");
        }
    },

    applicationErrorChecker: function() {
        var self = this;
        var parentElement = "#property-modifiers-menu";
        var incStep = "incomplete-step"

        $("#property-modifiers-menu .incomplete-step").removeClass(incStep)

        var embellishment = ApplicationCore.utilities.getAllEmbellishments();
        
        if (_.size(embellishment) > 0) {
            _.each(embellishment, function(application) {
                if (typeof application.embellishment !== "undefined") {
                    var designDetails = application.embellishment.design_details;

                    self.checkColorConflict(designDetails, function(hasConflict, colors) {
                        application.hasConflict = hasConflict;
                        application.numberOfConflict = _.size(colors);

                        if (hasConflict) {
                            if (application.logo_type === "custom_text") {
                                $(parentElement).find(".menu-item-letters").addClass(incStep);
                            } else if (application.logo_type === "stock" || application.logo_type === "custom") {
                                $(parentElement).find(".menu-item-applications").addClass(incStep);
                            }
                        } else {
                            delete application.hasConflict;
                        }
                    });
                }
            });
        }

        if (ub.data.showConflictingColorList) {
            ApplicationList.events.reloadConflict();
            ub.data.showConflictingColorList = false;
        }
    },

    findEmbellishmentWithError: function() {
        return _.find(ub.current_material.settings.applications, function(app) {
            if (app.hasConflict) {
                if (app.logo_type === "custom" || app.logo_type === "stock") {
                    return app;
                }
            }
        });
    }
}

